import React, { FunctionComponent } from "react";
import classes from "../Card/Card.module.scss";
import {Slide} from "react-awesome-reveal";

export type CardProps = {
    icon:string,
    title: string,
    paragraph: string,
    className: string,
}

export const Card: FunctionComponent<CardProps> = ({icon, title, paragraph, className}) =>
    <Slide triggerOnce direction="up" className={`${classes.serviceItem} ${className}`}>
        <div className={`${classes.media}`}>
            <div className={classes.iconContainer}>
                <div className={classes.icon}>
                    <span className={icon}/>
                </div>
            </div>
            <div className={classes.mediaBody}>
                <h3>{title}</h3>
                <p>{paragraph}</p>
            </div>
        </div>
    </Slide>;




